export default (props, vars) =>
  !!vars?.['uselookbook2']?.['lookbook']?.['about']?.[
    'show_final_output_enabled'
  ];
